import { _factors } from "./piste-scoring";
import type { NormalisedHour } from "./daily-obs-types";

export type VisHourCell = {
  hour: number;
  isDay: boolean;
  factor: number;
  colour: string;
  label: string;
};

/**
 * Maps a visibilityFactor value (0–1) and cloud cover percentage to a colour
 * hex token. Thresholds copied verbatim from SportHourlyTimeline.tsx.
 */
export function visColour(f: number, cloudPct = 0): string {
  if (f >= 0.9) return cloudPct < 25 ? "#059669" : "#10b981";
  if (f >= 0.7) return "#0d9488";
  if (f >= 0.5) return "#d97706";
  if (f >= 0.3) return "#ea580c";
  return "#dc2626";
}

/**
 * Maps a visibilityFactor value (0–1) and cloud cover percentage to a
 * human-readable label. Thresholds copied verbatim from SportHourlyTimeline.tsx.
 */
export function visLabel(f: number, cloudPct = 0): string {
  if (f >= 0.9) return cloudPct < 25 ? "Bluebird" : "Clear";
  if (f >= 0.7) return "Good";
  if (f >= 0.5) return "Moderate";
  if (f >= 0.3) return "Flat light";
  return "Fog";
}

/**
 * Builds a per-hour visibility cell series from NormalisedHour data.
 * Uses _factors.visibilityFactor (from piste-scoring) to compute the factor,
 * then applies visColour/visLabel with cloud_cover_pct as the cloud signal.
 */
export function buildVisHourSeries(hours: NormalisedHour[]): VisHourCell[] {
  return hours.map((h) => {
    const factor = _factors.visibilityFactor(h.weather);
    const cloudPct = h.weather.cloud_cover_pct;
    return {
      hour: h.hour,
      isDay: h.weather.is_day,
      factor,
      colour: visColour(factor, cloudPct),
      label: visLabel(factor, cloudPct),
    };
  });
}
